<template>
  <main class="main inside-page form-page recover-page">
    <div class="section recover-section">
      <div class="left">
        <div class="left-wrapper">
          <router-link to="/" class="logo">
            <img class="img" src="../images/logo.svg" />
            <div class="title tiny">Elystr</div>
          </router-link>
          <div class="title">
            {{ $t("Recover") }}
          </div>
          <ValidationObserver
            ref="form"
            v-slot="{ handleSubmit }"
            slim
            class="form"
          >
            <form @submit.prevent="handleSubmit(submit)" class="form">
              <ValidationProvider
                rules="required|email"
                v-slot="{ errors }"
                vid="email"
                slim
              >
                <label class="label">
                  <div class="desc desc-12">
                    <b>{{ $t("Email") }}:</b>
                  </div>
                  <input
                    required
                    name="email"
                    v-model="email"
                    type="email"
                    :placeholder="$t('Enter your email')"
                  />
                  <div v-if="errors.length" class="error">
                    {{ errors[0] }}
                  </div>
                </label>
              </ValidationProvider>
              <div class="button-container">
                <button class="button colored">{{ $t("Continue") }}</button>
              </div>
              <div class="center-link-container">
                <div class="desc">{{ $t("Don't have an account?") }}</div>
                <router-link to="/register" class="desc link">
                  <b>{{ $t("Sign Up") }}</b>
                </router-link>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
      <div class="right"></div>
    </div>
  </main>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import axios from "@/axios";
import { mapActions } from "vuex";

export default {
  name: "Recover",
  props: [],
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data: function () {
    return {
      email: "",
    };
  },
  mounted() {},
  methods: {
    submit() {
      const self = this;

      axios
        .post("user/request-password-reset", {
          email: this.email,
        })
        .then(({ data }) => {
          if (data.status === "OK") {
            self.email = "";
            this.$refs.form.reset();
            self.showNotification({
              text: this.$t(
                "We've sent you an email with a link to reset your password. Please check your e-mail"
              ),
            });
          } else if (data.status === "ERROR") {
            self.showNotification({ text: data.message });
          }
        })
        .catch(({ response }) => {
          if (response.data.status === "ERROR") {
            self.showNotification({ text: response.data.message });
          }
        });
    },
    ...mapActions("app", ["showNotification"]),
  },
};
</script>
